import { FC } from 'react'
import { ReactComponent as TargetIcon } from 'src/assets/svg/camp-card.svg'
import { Skeleton } from 'src/components/Skeleton'
import styles from './totalCampaignsCard.module.scss'

interface TotalCampaignsCardProps {
  activeCount?: number
  hasData?: boolean
  isLoading?: boolean
  totalCount?: number
}

export const TotalCampaignsCard: FC<TotalCampaignsCardProps> = ({
  activeCount = 5,
  hasData = false,
  isLoading = false,
  totalCount = 8,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <TargetIcon className={styles.icon} />
        <h3 className={styles.title}>Total Campaigns</h3>
      </div>
      {/* Loading is checked BEFORE hasData: while the query is in flight the
          counts are 0, and rendering "0 Active / out of 0 total" states a fact
          we do not have yet. .mainValue is 32px and .subText 16px (see
          totalCampaignsCard.module.scss) — the skeletons mirror those. */}
      {isLoading ? (
        <div className={styles.content}>
          <Skeleton height={32} width={132} />
          <Skeleton height={16} width={104} />
        </div>
      ) : hasData ? (
        <div className={styles.content}>
          <div className={styles.mainValue}>{activeCount} Active</div>
          <div className={styles.subText}>out of {totalCount} total</div>
        </div>
      ) : (
        <div className={styles.noData}>No Data</div>
      )}
    </div>
  )
}
